import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectSpread2 from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { isValidElement, cloneElement } from 'react';
import { defaultProps } from '../utils/defaultProps';

var DefaultProps = _objectSpread2(_objectSpread2({}, defaultProps), {}, {
  data: {},
  renderItem: 'content'
});

var Item =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Item, _React$PureComponent);

  var _super = _createSuper2(Item);

  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Item, [{
    key: "handleClick",
    value: function handleClick() {
      if (!this.props.onClick) return;
      this.props.onClick(this.props.data);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          data = _this$props.data,
          itemClassName = _this$props.itemClassName,
          renderItem = _this$props.renderItem,
          width = _this$props.width,
          columns = _this$props.columns;
      var aWidth = width && columns ? (width - 2) / columns : undefined;
      var props = {
        disabled: data.disabled,
        onClick: this.handleClick,
        className: itemClassName,
        target: data.target,
        style: aWidth ? {
          display: 'inline-block',
          width: aWidth
        } : null
      };
      if (data.url) props.href = data.url;
      var content;

      if (
      /*#__PURE__*/
      isValidElement(data)) {
        content = data;
      } else {
        // @ts-ignore
        content = typeof renderItem === 'string' ? data[renderItem] : renderItem(data);
      }

      if (
      /*#__PURE__*/
      isValidElement(content)) {
        return (
          /*#__PURE__*/
          cloneElement(content, Object.assign(props, content.props))
        );
      }

      return (
        /*#__PURE__*/
        React.createElement("a", props, content)
      );
    }
  }]);

  return Item;
}(React.PureComponent);

Item.defaultProps = DefaultProps;
export default Item;